"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isICanMarkAsNoShow = void 0;
const core_types_1 = require("@dqm/core-types");
function isICanMarkAsNoShow(markAsNoShowService) {
    if (!(0, core_types_1.isObject)(markAsNoShowService)) {
        return false;
    }
    if (typeof markAsNoShowService.markAsNoShow !== "function") {
        return false;
    }
    return true;
}
exports.isICanMarkAsNoShow = isICanMarkAsNoShow;
//# sourceMappingURL=ICanMarkAsNoShow.js.map